import { Component, Input, inject } from '@angular/core';
import { AppstateService } from '../../../../core/appstate/appstate.service';

@Component({
  selector: 'app-item',
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss'
})
export class ItemComponent {
  @Input() icon = ""
  @Input() translationKey = ""
  @Input() route = ""

  appStateService = inject(AppstateService);

  collapsed = this.appStateService.collapsed;
}
